// ============================================================
// 非同步打卡 task 狀態機
// ------------------------------------------------------------
// 把 Firestore document 的 status 映射成前端要做的動作，集中在一處方便單元測試。
// 監聽端（firestorePunchWatcher）只負責把 doc 餵進來，根據結果分流。
// ============================================================

// Firestore 打卡 task 的生命週期狀態：
//   accepted / processing / published → loading（尚未收尾）
//   succeeded → 成功
// 	 failed → 失敗（帶 error_code / error_message）
//   publish_failed → BE 建 doc 成功但推 Pub/Sub 失敗，前端產新 idempotency_key 重打 /enqueue
export type PunchTaskStatus =
	| 'accepted'
	| 'processing'
	| 'published'
	| 'succeeded'
	| 'failed'
	| 'publish_failed';

export interface PunchTaskDoc {
	status: PunchTaskStatus;
	error_code?: string;
	error_message?: string;
	punch_in_record_id?: string | null;
}

// 前端對一份 doc 的處置：
//   loading    → accepted / processing / published，持續等待，按鈕維持互動鎖但不變灰
//   success    → succeeded，打卡成功
//   fail       → failed，打卡失敗（帶 error_code / error_message）
//   republish  → publish_failed，需產新 idempotency_key 重打 /enqueue

export type PunchTaskAction =
	| { type: 'loading' }
	| { type: 'success' }
	| { type: 'fail'; errorCode?: string; errorMessage?: string }
	| { type: 'republish' };

export const classifyPunchTaskDoc = (doc: PunchTaskDoc | null | undefined): PunchTaskAction => {
	if (!doc) return { type: 'loading' };
	switch (doc.status) {
	case 'succeeded':
		return { type: 'success' };
	case 'failed':
		return { type: 'fail', errorCode: doc.error_code, errorMessage: doc.error_message };
	case 'publish_failed':
		return { type: 'republish' };
	case 'accepted':
	case 'processing':
	case 'published':
		return { type: 'loading' };
	default:
		return { type: 'loading' };
	}
};
